import React from "react";
import Title from "../../../components/Title/Title";

const AreaChair2026page = () => {
    return (
        <div>
            <Title>Area Chairs</Title>
            Bo Han (Hong Kong Baptist University)<br />
            Bryon Aragam (University of Chicago)<br />
            David Danks (University of California, San Diego)<br />
            Emre Kıcıman (Microsoft Research)<br />
            Francesco Locatello (Institute of Science and Technology Austria)<br />
            Jiji Zhang (Chinese University of Hong Kong)<br />
            Kun Zhang (Carnegie Mellon University)<br />
            Negar Kiyavash (EPFL)<br />
            Peter Spirtes (Carginie Mellon University)<br />
            Ricardo Silva (University College London)<br />
            Shohei Shimizu (Shiga University)<br />
            Sofia Triantafillou (University of Crete)<br />
        </div>
    )
}

export default AreaChair2026page
